/**
 * Account model for account lookup response
 */
export class AccountLookUp {
  public AccountNumber: string = '';
  public IsLimitedPayOptions?: boolean = false;
  public FirstName?: string;
  public LastName?: string;
  public FullName?: string;
  public Email?: string;
  public CurrentBalance?: number;
  public IsPaymentAllowed?: boolean;
  public IsInSeverance?: boolean;
  public PastDueBalance?: number;
  public MinimumPayment?: number;
  public BillingState?: string;
  public BillingZipCode?: string;
  public BillDate?: string;
  public BillDueDate?: string;
  public BillAmount?: number;
  public AuthToken?: string;
  public AuthTokenExpiration?: Date;
}
